<template>
  <v-dialog v-model="showTaggerModal">

    <v-card>

      <v-card-title>
        <v-row>
          <v-col>
            <div class="float-left">Edit Tags</div>
          </v-col>
          <v-col>
            <div class="float-right">

              <v-btn  class='ma-1' @click="closeTaggerModal()">Cancel</v-btn>
              <v-btn :disabled="!hasChanges" class='ma-1' color="primary" @click="saveChanges()">Save Changes</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <inner-image-zoom :src="photo_rec.image_url" className="tag-image-zoom" moveType="drag"/>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col cols="12">
                <v-chip v-for="tag in photo_rec.tags" :key="tag.id"
                        class="ma-1 v-size--small"
                        close
                        @click:close="removeTag(tag)"
                >
                  {{ tag.name }}
                  <v-chip
                      outlined
                      props: style="border-width: 0;"
                      x-small

                  >
                    <v-spacer>{{ tag.category.name }}</v-spacer>
                  </v-chip>
                </v-chip>


              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-select
                    v-model="selectedCategory"
                    :items="allCats"
                    item-text="name"
                    item-value="id"
                    label="Category"
                    @change="filterTags(selectedCategory)"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                    v-model="selectedTags"
                    :items="filteredTags"
                    chips
                    item-text="name"
                    label="Tags"
                    multiple
                    return-object
                ></v-select>
              </v-col>
              <v-col cols="2">
                <v-btn :disabled="!selectedTags.length" color="primary" @click="addTags()">Add Tags</v-btn>
              </v-col>
            </v-row>
          </v-col>

        </v-row>
      </v-card-text>

    </v-card>

  </v-dialog>
</template>

<script>
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css'
import {mapActions, mapGetters, mapState} from 'vuex'
import InnerImageZoom from 'vue-inner-image-zoom'

export default {
  name: 'TaggerModal',
  components: {
    'inner-image-zoom': InnerImageZoom
  },
  props: {
    photo_rec: Object
  },
  data() {
    return {
      searchInput: null,
      selectedCategory: null,
      selectedTags: [],
      filteredTags: [],
      isModalVisible: false,
      hasChanges: false,
    }
  },
  mounted() {
    // this.setFilteredTags(this.$store.state.tags.tags)
    // this.setSelectedTagsModal(this.$store.state.tags.selectedTags)
    this.filteredTags = this.tags
    this.hasChanges = false

  },
  computed: {
    ...mapGetters(['getCategoryNames', 'getTagNames']),
    ...mapState({

      tags: state => state.tags.tags,
      categories: state => state.categories.categories,

      allCats() {
        var cats = this.categories
        cats = cats.map(cat => ({id: cat.id, name: cat.name}))
        cats.unshift({id: 0, name: 'All'})

        return cats
      }
    })
  },
  methods: {
    ...mapActions([
      'bulkUpdate',
      'submitAssigned',
    ]),
    filterTags(e) {
      if (e !== 0) {
        var filteredTags = this.tags.filter(tag => tag.category.id === parseInt(e))
      } else {
        filteredTags = this.tags
      }
      this.filteredTags = filteredTags
    },
    selectedTagsChanged(tags) {
      for (let tag of tags) {
        if (!this.photoHasTag(tag)) {
          this.photo_rec.tags.push(tag)
        }
      }
    },
    addTags() {
      for (let tag of this.selectedTags) {
        if (!this.photoHasTag(tag)) {
          this.photo_rec.tags.push(tag)
          this.hasChanges = true
        }
      }
      this.selectedTags = []
    },
    photoHasTag(tag) {
      for (let photoTag of this.photo_rec.tags) {
        if (photoTag.id === tag.id) {
          return true
        }
      }
      return false
    },
    saveChanges() {
      let selectedPhoto = this.photo_rec
      let dialog = this;
      let currentTags = selectedPhoto.tags.map(tag => tag.id);
      let payload = {
        selected_photos: [selectedPhoto.id],
        selected_tags: currentTags,
        isQc: false,
        needs_review: false
      };
      this.bulkUpdate(payload).then(() => {
        dialog.hasChanges = false
        dialog.closeTaggerModal()
      })
    },
    showTaggerModal() {
      this.isModalVisible = true
    },
    closeTaggerModal() {
      this.isModalVisible = false
      this.$emit('close')
    },
    removeTag(tag) {
      for (let index = this.photo_rec.tags.length - 1; index >= 0; index--) {
        if (this.photo_rec.tags[index].id === tag.id) {
          this.photo_rec.tags.splice(index, 1)
          this.hasChanges = true
        }
      }
    }
  }
}
</script>

<style>
.v-chip .v-chip__content {
  height: auto !important;
}

.flex-container {
  display: flex;
  justify-content: center;
}

#image-container {
  flex: 1;
  margin: auto;
  padding-left: 1vw;
  padding-top: 1vh;
}

#tagging-menu {
  flex: 2;
  max-width: 100%;
  padding-left: 1vw;
  padding-right: 1vw;
  margin: auto;
}

.tag-image-zoom {
  height: 90%;
  max-height: 90%;
}

@media (min-width: 960px) {
  .tag-image-zoom {
    width: 480px;
    max-width: 480px;
  }
}

@media (min-width: 1264px) {
  .tag-image-zoom {
    width: 632px;
    max-width: 632px;
  }
}

@media (min-width: 1904px) {
  .tag-image-zoom {
    width: 920px;
    max-width: 920px;
  }
}


</style>
